module.exports = __webpack_public_path__ + "static/img/banner2_img.b324b3e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/banner2_img.png
// module id = o1hi
// module chunks = 1